import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import useOnScreen from '../../../ui/hooks/useOnScreen'

import { ReactComponent as PlayCircleXL } from '../../../../images/svg/playCircleXL.svg'
import noMediaImage from '../../../../images/svg/noMedia.svg'

const StyledRoot = styled.div(() => ({
  position: 'relative',
  display: 'flex',
  maxHeight: 'inherit',
  maxWidth: 'inherit',
  background: 'transparent',
}))

const StyledImage = styled.img(({ render }) => ({
  width: '100%',
  maxWidth: '100%',
  objectFit: 'scale-down',
  opacity: render ? 1 : 0,
  transition: 'opacity .3s ease-in',
}))

const StyledPlayButton = styled.button(({ size }) => ({
  position: 'absolute',
  zIndex: '1',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: size || '120px',
  height: size || '120px',
  border: 'none',
  borderRadius: '60px',
  padding: 10,
  backgroundColor: 'rgba(40, 40, 50, .4)',
  maxWidth: '100%',
  maxHeight: '100%',
}))

const VideoThumb = ({
  src, lazy, onClick, onLoad, size, containerRef,
}) => {
  const [render, setRender] = React.useState(!lazy)
  const thumbRef = useRef()

  useOnScreen({
    target: thumbRef,
    onEnterScreen: () => {
      if (lazy) setRender(true)
    },
  }, { root: containerRef })

  return (
    <StyledRoot data-test="VideoThumb">
      <StyledPlayButton size={size}>
        <PlayCircleXL fill="white" onClick={onClick} data-test="VideoThumbPlay" />
      </StyledPlayButton>
      <StyledImage
        ref={thumbRef}
        render={render}
        onLoad={onLoad}
        onClick={onClick}
        src={render ? src : noMediaImage}
      />
    </StyledRoot>
  )
}

VideoThumb.propTypes = {
  src: PropTypes.string,
  lazy: PropTypes.bool,
  size: PropTypes.number,
  containerRef: PropTypes.shape({}),
  onClick: PropTypes.func,
  onLoad: PropTypes.func,
}

VideoThumb.defaultProps = {
  src: '',
  lazy: true,
  size: 0,
  containerRef: null,
  onClick: () => false,
  onLoad: () => false,
}

VideoThumb.displayName = 'VideoThumb'
VideoThumb.whyDidYouRender = true

export default VideoThumb
